import { render, staticRenderFns } from "./IconDescriptionSection.vue?vue&type=template&id=34bdb8b8&"
import script from "./IconDescriptionSection.vue?vue&type=script&lang=js&"
export * from "./IconDescriptionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports